import React from 'react';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { ResidentialShowcase } from './components/ResidentialShowcase';
import { CommercialShowcase } from './components/CommercialShowcase';
import { CommercialReviews } from './components/CommercialReviews';
import { ServiceDetails } from './components/ServiceDetails';
import { Testimonials } from './components/Testimonials';
import { GoogleReviews } from './components/GoogleReviews';
import { CTASection } from './components/CTASection';
import { ContactSection } from './components/ContactSection';
import { AboutSection } from './components/AboutSection';
import { AppointmentSection } from './components/AppointmentSection';
import { FinancingSection } from './components/FinancingSection';
import { FAQSection } from './components/FAQSection';
import { BlogSection } from './components/BlogSection';
import { ServiceAreaMap } from './components/ServiceAreaMap';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';

function HablamosEspanolBanner() {
  return (
    <div className="bg-[#FF6B35] py-4">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-center gap-3">
        <i className="ri-translate-2 text-white text-2xl"></i>
        <span className="text-white font-semibold text-lg">¡Hablamos Español!</span>
        <span className="text-white/90 text-sm hidden sm:inline">- We speak Spanish to serve you better</span>
      </div>
    </div>
  );
}

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <ResidentialShowcase />
      <CommercialShowcase />
      <CommercialReviews />
      <ServiceDetails />
      <AboutSection />
      <AppointmentSection />
      <Testimonials />
      <GoogleReviews />
      <FinancingSection />
      <FAQSection />
      <BlogSection />
      <ServiceAreaMap />
      <ContactSection />
      <CTASection />
      <HablamosEspanolBanner />
      <Footer />
    </div>
  );
}
